import { Box, Typography } from '@mui/material'
import { AnnualPlanStatus } from '../../models/AnnualPlanStatus'

interface Props {
  status: AnnualPlanStatus
  schoolYear?: string
  dataTestId?: string
}

export const AnnualPlanStatusChip = ({ status, schoolYear, dataTestId }: Props): JSX.Element => {
  let backgroundColor = 'var(--green-500)'
  if (status === AnnualPlanStatus.NotStarted) {
    backgroundColor = 'var(--purple-500)'
  } else if (status === AnnualPlanStatus.NoPlan) {
    backgroundColor = 'var(--red-500)'
  }

  const label = schoolYear != null ? `${schoolYear} · ${status}` : status

  return (
    <Box
      data-testid={dataTestId ?? 'annual-plan-status-chip'}
      sx={{
        padding: '6px 20px',
        borderRadius: '60px',
        backgroundColor,
        color: 'var(--white)',
        maxWidth: '100%'
      }}
    >
      <Typography
        variant='body1'
        sx={{ fontWeight: '600', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {label}
      </Typography>
    </Box>
  )
}
